// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import { useState, useEffect, useRef } from 'react';

// Material UI
import {
  Box,
  Button,
  IconButton,
  Typography,
  Zoom,
} from "@mui/material";
import { styled } from '@mui/material/styles';



// ----------------------------------------------------------------------------
//   Button Components
// ----------------------------------------------------------------------------


/**
 * Base styling for an action button.
 */
export const ActionButtonBase = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#4447ad",
  '&:hover': {
    backgroundColor: "#6863d6",
  },
  '&:disabled': {
    backgroundColor: "lightgray",
    color: "darkgray",
  },
}));


/**
 * Main action button to progress through the exercise.
 * Styled for overlay on black card background.
 */
export function ActionButtonOverlay({ content, visible, ...buttonProps }) {
  return (
    <Zoom in={ visible } unmountOnExit>
      <Box>
        <Box
          sx = {{
            'transitionBehavior': 'normal',
            'transitionDelay':    '0s',
            'transitionDuration': '0.25s',
            'transitionProperty': 'transform, box-shadow',
            'transitionTimingFunction': 'cubic-bezier(0.4, 0, 0.2, 1)',
            'borderRadius': 4,
            '&:hover': {
              transform: "scale(1.02)",
              boxShadow: "#b39fe788 0 0 8px 4px",
            },
          }}
        >
          <ActionButtonBase
            variant = "contained"
            sx={{
              paddingY: 3,
              paddingX: 4,
              borderRadius: 4,
            }}
            { ...buttonProps }
          >
            <Typography sx={{ fontSize: "1.5em", lineHeight: "unset" }}>
              { content }
            </Typography>
          </ActionButtonBase>
        </Box>
      </Box>
    </Zoom>
  )
}


/**
 * Main action button to progress through the exercise.
 * Styled for placement on site background color (same level as a card).
 */
export function ActionButtonFullwidth({ content, disabled, ...buttonProps }) {
  return (
    <Zoom in={ !disabled }>
      <Box>
        <Box
          sx = {{
            'transitionBehavior': 'normal',
            'transitionDelay':    '0s',
            'transitionDuration': '0.25s',
            'transitionProperty': 'transform, box-shadow',
            'transitionTimingFunction': 'cubic-bezier(0.4, 0, 0.2, 1)',
            'borderRadius': 4,
            '&:hover': {
              transform: "scale(1.02)",
              boxShadow: "#b39fe788 0 0 8px 4px",
            },
          }}
        >
          <ActionButtonBase
            fullWidth
            sx = {{
              padding: 2,
            }}
            disabled = { disabled }
            { ...buttonProps }
          >
            { content }
          </ActionButtonBase>
        </Box>
      </Box>
    </Zoom>
  )
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------


export default {
  ActionButtonOverlay,
  ActionButtonFullwidth,
}
